type CheckAdminViewProps = {
  shouldOverrideAdminView?: boolean;
}

export const checkAdminView = ({ shouldOverrideAdminView = false }: CheckAdminViewProps = {}): boolean => {
  if (shouldOverrideAdminView) {
    return false;
  }
  return location.pathname.indexOf('/administration') !== -1;
}